// src/api/nom35SecIAnalyticsApi.js
import apiClient from "./apiClient";
import nomAnalyticsFilters from "./nomAnalyticsFilters";

function filenameFromContentDisposition(disposition, fallback) {
  if (!disposition) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/i.exec(disposition);
  if (!match) return fallback;
  try { return decodeURIComponent(match[1]); } catch { return match[1]; }
}

const nom35SecIAnalyticsApi = {
  getScopeConfig: async (scopeId, filters = {}) => {
    const response = await apiClient.get(`/analytics/nom035SecI/${scopeId}/scope-config`, { params: nomAnalyticsFilters(scopeId, filters) });
    return response.data;
  },
  /**
   * Resumen requireClinicalAttention por empresa
   */
  getClinicalSummaryByCompanyId: async (companyId, filters = {}) => {
    try {
      const response = await apiClient.get(
        `/analytics/nom035SecI/${companyId}/responses/clinical-summary`,
        { params: nomAnalyticsFilters(companyId, filters) }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo clinical summary NOM-035 Sec I por empresa:", error);
      throw error;
    }
  },

  /**
   * Resumen global requireClinicalAttention
   */
  getClinicalSummaryGlobal: async (filters = {}) => {
    try {
      const response = await apiClient.get(
        `/analytics/nom035SecI/responses/clinical-summary`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo clinical summary global NOM-035 Sec I:", error);
      throw error;
    }
  },

  /**
   * Total de respuestas por empresa
   */
  getResponsesCountByCompanyId: async (companyId, filters = {}) => {
    try {
      const response = await apiClient.get(
        `/analytics/nom035SecI/${companyId}/responses/count`,
        { params: nomAnalyticsFilters(companyId, filters) }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo total de respuestas NOM-035 Sec I por empresa:", error);
      throw error;
    }
  },

  /**
   * Total global de respuestas
   */
  getResponsesCountGlobal: async () => {
    try {
      const response = await apiClient.get(`/analytics/nom035SecI/responses/count`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo total global de respuestas NOM-035 Sec I:", error);
      throw error;
    }
  },

  /**
   * Lista de respondants (JSON)
   */
  getRespondantsByCompanyId: async (companyId, applicationId) => {
    try {
      const response = await apiClient.get(
        `/analytics/nom035SecI/${companyId}/respondants`,
        { params: nomAnalyticsFilters(companyId, applicationId) }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo respondants NOM-035 Sec I por empresa:", error);
      throw error;
    }
  },

  /**
   * Export respondants (Excel): devuelve { blob, filename }
   */
  getRespondantsByCompanyIdExport: async (companyId, applicationId) => {
    try {
      const response = await apiClient.get(
        `/analytics/nom035SecI/${companyId}/respondants/export`,
        {
          responseType: "blob",
          params: nomAnalyticsFilters(companyId, applicationId),
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        }
      );

      const filename = filenameFromContentDisposition(
        response.headers["content-disposition"],
        `nom035-seci-respondants-${companyId}.xlsx`
      );

      return { blob: response.data, filename };
    } catch (error) {
      console.error("Error exportando respondants NOM-035 Sec I por empresa:", error);
      throw error;
    }
  },

  /**
   * Helper para descargar directo en el navegador
   */
  downloadRespondantsByCompanyIdExcel: async (companyId, applicationId) => {
    const { blob, filename } =
      await nom35SecIAnalyticsApi.getRespondantsByCompanyIdExport(companyId, applicationId);

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || `nom035-seci-respondants-${companyId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};

export default nom35SecIAnalyticsApi;
